<script>
import { mapActions, mapGetters } from "vuex";
import {
  required,
  sameAs,
  minLength,
  requiredIf,
  between,
} from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import Collapsible from "vue-collapsible-component";
import moment from "moment";

export default {
  name: "UpdateActionForm",
  components: { DatePicker, Collapsible },
  props: ["modal_id"],
  data() {
    return {
      isPasswordSettingsOpened: false,
      kioskId: null,
      area_mode: null,
      serial_number: null,
      timeZoneName: null,
      current_kiosk_password: null,
      old_kiosk_password: null,
      dateFormatOptions: ["yyyy-MM-dd", "dd-MM-yyyy", "MM-dd-yyyy"],
      form: {
        kiosk: {
          name: null,
          area_id: null,
        },
        kiosk_setting: {
          temperature_offset: 0,
          kiosk_brightness: 65,
          schedule_reboot: null,
          kiosk_volume: 50,
          kiosk_password: null,
          confirm_kiosk_password: null,
          temperature_display_unit: null,
          time_zone: null,
          schedule_reboot_time: "03:00",
          system_fan: 0,
          enable_company_logo: 1,
          living_body: 1,
          card_logo_image: "",
          date_format: "yyyy-mm-dd",
          show_status_bar: 0,
          rfid_counter: 5,
          weigand_output_type: 26,
          custom_smtp_server: 0,
          smtp_address: null,
          smtp_username: null,
          smtp_password: null,
          smtp_port: null,
          smtp_tls: 0,
          smtp_ssl: 0,
          door_relay_mode: "mode0",
          closing_delay: "5",
          kiosk_sign_in_out_mode: "sign_in_out",
          show_pre_registration_qr : true
        },
      },
      submitted: false,
      timezoneObject: null,
      signInOutModeOptions: [
        { text: this.$t('sitesAndDevices.kioskActions.signInOnly'), value: "sign_in_only" },
        { text: this.$t('sitesAndDevices.kioskActions.signOutOnly'), value: "sign_out_only" },
        { text: this.$t('sitesAndDevices.kioskActions.bothSignInAndSignOut'), value: "sign_in_out" },
      ],
    };
  },
  destroyed() {
    this.isPasswordSettingsOpened = false;
  },
  validations: {
    form: {
      kiosk: {
        name: { required },
        area_id: { required },
      },
      kiosk_setting: {
        kiosk_password: { minLength: minLength(6) },
        confirm_kiosk_password: { sameAsPassword: sameAs("kiosk_password") },
        smtp_port: {
          required: requiredIf(function () {
            return this.form.kiosk_setting.custom_smtp_server;
          }),
        },
        smtp_address: {
          required: requiredIf(function () {
            return this.form.kiosk_setting.custom_smtp_server;
          }),
        },
        smtp_username: {
          required: requiredIf(function () {
            return this.form.kiosk_setting.custom_smtp_server;
          }),
        },
        smtp_password: {
          required: requiredIf(function () {
            return this.form.kiosk_setting.custom_smtp_server;
          }),
        },
        closing_delay: { required, between: between(1, 99999) },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("sites", ["getLoading"]),
    ...mapGetters("kiosks", ["getLoading"]),
    ...mapGetters("authfack", ["currentEntity"]),
    getPackageType() {
      const { currentEntity } = this;
      return currentEntity && currentEntity.package;
    },
  },
  methods: {
    ...mapActions("kiosks", ["updateKiosk"]),
    checkIfValueIsNull() {
      if (Number(this.form.kiosk_setting.closing_delay) <= 0)
        this.form.kiosk_setting.closing_delay = "1";
    },
    clearRebootTime() {
      this.form.kiosk_setting.schedule_reboot_time = "00:00:00";
    },
    onSubmit() {
      this.form.kiosk_setting.time_zone = this.timeZoneName
        ? this.timeZoneName
        : null;

      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (
          this.current_kiosk_password ||
          this.form.kiosk_setting.kiosk_password ||
          this.form.kiosk_setting.confirm_kiosk_password
        ) {
          if (
            !this.current_kiosk_password ||
            !this.form.kiosk_setting.kiosk_password ||
            !this.form.kiosk_setting.confirm_kiosk_password
          ) {
            this.$toast.error(
              "To update the password please ensure all fields are filled.",
              {
                position: "top-right",
              }
            );
          }
          if (this.current_kiosk_password != this.old_kiosk_password) {
            this.$toast.error("Current kiosk password is not correct", {
              position: "top-right",
            });
          } else {
            this.updateKiosk({
              id: this.kioskId,
              params: this.form,
            }).then(async () => this.$emit("kioskUpdated"));
          }
        } else {
          this.updateKiosk({
            id: this.kioskId,
            params: this.form,
          }).then(async () => this.$emit("kioskUpdated"));
        }
      }
    },
  },
  beforeMount() {
    console.log("Before mount", this.getModalInfo);
    this.siteInfoLength =
      this.getModalInfo && Object.keys(this.getModalInfo).length > 0
        ? true
        : false;
    if (this.siteInfoLength) {
      const { id, name, area_id, setting, serial_number, area_mode } = this.getModalInfo;
      this.kioskId = id;
      this.area_mode = area_mode;
      this.serial_number = serial_number;
      this.form.kiosk.name = name;
      this.form.kiosk.area_id = area_id;
      this.form.kiosk.package = this.getModalInfo.package;
      setting &&
        setting.length > 0 &&
        setting.map((item) => {
          item.name == "kiosk_password"
            ? (this.old_kiosk_password = item.pivot.value)
            : "";
          item.name == "temperature_display_unit"
            ? (this.form.kiosk_setting.temperature_display_unit =
                item.pivot.value)
            : "";
          item.name == "temperature_offset"
            ? (this.form.kiosk_setting.temperature_offset = Number(
                item.pivot.value
              ))
            : "";
          item.name == "schedule_reboot"
            ? (this.form.kiosk_setting.schedule_reboot =
                item.pivot.value == 1 ? true : false)
            : "";
          item.name == "kiosk_volume"
            ? (this.form.kiosk_setting.kiosk_volume = Number(item.pivot.value))
            : "";
          item.name == "kiosk_brightness"
            ? (this.form.kiosk_setting.kiosk_brightness = Number(
                item.pivot.value
              ))
            : "";
          // new settings
          item.name == "time_zone"
            ? (this.timeZoneName = item.pivot.value)
            : "";
          item.name == "schedule_reboot_time"
            ? (this.form.kiosk_setting.schedule_reboot_time = item.pivot.value)
            : "";
          item.name == "system_fan"
            ? (this.form.kiosk_setting.system_fan =
                item.pivot.value == 1 ? true : false)
            : "";
          item.name == "enable_company_logo"
            ? (this.form.kiosk_setting.enable_company_logo = item.pivot.value)
            : "";
          item.name == "living_body"
            ? (this.form.kiosk_setting.living_body =
                item.pivot.value == 1 ? true : false)
            : "";
          item.name == "date_format"
            ? (this.form.kiosk_setting.date_format =
                item.pivot.value == "yyyy-MM-dd"
                  ? "yyyy-mm-dd"
                  : item.pivot.value)
            : "";
          item.name == "show_status_bar"
            ? (this.form.kiosk_setting.show_status_bar =
                item.pivot.value == 1 ? true : false)
            : "";
          item.name == "kiosk_brightness"
            ? (this.form.kiosk_setting.kiosk_brightness = Number(
                item.pivot.value
              ))
            : "";
          item.name == "rfid_counter"
            ? (this.form.kiosk_setting.rfid_counter = Number(item.pivot.value))
            : "";
          item.name == "weigand_output_type"
            ? (this.form.kiosk_setting.weigand_output_type = item.pivot.value)
            : "";
          item.name == "smtp_address"
            ? (this.form.kiosk_setting.smtp_address = item.pivot.value)
            : "";
          item.name == "smtp_port"
            ? (this.form.kiosk_setting.smtp_port = item.pivot.value)
            : "";
          item.name == "smtp_username"
            ? (this.form.kiosk_setting.smtp_username = item.pivot.value)
            : "";
          item.name == "smtp_password"
            ? (this.form.kiosk_setting.smtp_password = item.pivot.value)
            : "";
          item.name == "smtp_tls"
            ? (this.form.kiosk_setting.smtp_tls =
                item.pivot.value == 1 ? true : false)
            : "";
          item.name == "smtp_ssl"
            ? (this.form.kiosk_setting.smtp_ssl =
                item.pivot.value == 1 ? true : false)
            : "";
          item.name == "custom_smtp_server"
            ? (this.form.kiosk_setting.custom_smtp_server =
                item.pivot.value == 1 ? true : false)
            : "";
          item.name == "kiosk_sign_in_out_mode"
            ? (this.form.kiosk_setting.kiosk_sign_in_out_mode = item.pivot.value)
            : "";
          item.name == "show_pre_registration_qr"
            ? (this.form.kiosk_setting.show_pre_registration_qr = item.pivot.value == 1 ? true : false)
            : "";
          if (item.name == "door_relay_mode")
            this.form.kiosk_setting.door_relay_mode = item.pivot.value;
          if (item.name == "closing_delay")
            this.form.kiosk_setting.closing_delay = item.pivot.value;
        });
    }
    this.timezoneObject = moment.tz.names();
  },
};
</script>

<template>
  <div class="kiosk-form-wrapper">
    <h4 class="allareakiosk-header">{{ $t('sitesAndDevices.kioskActions.kioskSettings')  }}</h4>
    <div v-if="getPackageType == 'Standalone'">
      <p class="text-danger" v-html="$t('sitesAndDevices.kioskActions.standaloneWarning')">
      </p>
    </div>
    <!-- switchs  -->
    <div class="switchs-wrapper" v-if="getPackageType == 'Cloud'">
      <div class="kiosk-switch-settings">
        <!-- system fan -->
        <b-form-group :label="$t('sitesAndDevices.kioskActions.systemFan')" label-for="system_fan">
          <b-form-checkbox
            size="md"
            class="switch-gray radio-updateArea"
            switch
            v-model="form.kiosk_setting.system_fan"
          ></b-form-checkbox>
        </b-form-group>
        <div class="line-betwen"></div>
        <!-- schedule reboot -->
        <b-form-group :label="$t('sitesAndDevices.kioskActions.scheduleReboot')" label-for="schedule_reboot">
          <b-form-checkbox
            class="switch-gray radio-updateArea"
            switch
            size="md"
            v-model="form.kiosk_setting.schedule_reboot"
          ></b-form-checkbox>
        </b-form-group>
        <div class="line-betwen"></div>
        <!-- living body -->
        <b-form-group :label="$t('sitesAndDevices.kioskActions.livingBody')" label-for="living_body">
          <b-form-checkbox
            class="switch-gray radio-updateArea"
            switch
            size="md"
            v-model="form.kiosk_setting.living_body"
          ></b-form-checkbox>
        </b-form-group>
        <div class="line-betwen"></div>

        <!-- status bar -->
        <b-form-group :label="$t('sitesAndDevices.kioskActions.hideStatusBar')" label-for="status_bar">
          <b-form-checkbox
            class="switch-gray radio-updateArea"
            switch
            size="md"
            v-model="form.kiosk_setting.show_status_bar"
          ></b-form-checkbox>
        </b-form-group>
      </div>
    </div>

    <div class="form-groups multi-inputs">
      <div class="actionsline-inside"></div>
      <!-- name   -->
      <vpInput
        :label="$t('common.name')"
        width="415"
        v-model="form.kiosk.name"
        class="vp-mb-16"
        :invalid="submitted && $v.form.kiosk.name.$error"
      />

      <!-- date format   -->
      <b-form-group v-if="getPackageType == 'Cloud'">
        <vp-multiselect
          v-model="form.kiosk_setting.date_format"
          width="415"
          :options="dateFormatOptions"
          type="text"
          :placeholder="$t('sitesAndDevices.kioskActions.dateFormat')"
          :allowEmpty="true"
          zIndex="5"
        />
      </b-form-group>
      <!-- timezone  -->
      <b-form-group v-if="getPackageType == 'Cloud'">
        <vp-multiselect
          v-model="timeZoneName"
          :options="timezoneObject"
          :placeholder="$t('common.timezone')"
          :show-labels="false"
          :allowEmpty="true"
          :disabled="true"
        />
      </b-form-group>

      <!-- schedule_reboot_time  -->
      <div class="robot-time" style="width: 415px">
        <b-form-group
          v-if="getPackageType == 'Cloud'"
          label-cols-sm="6"
          label-cols-lg="6"
          :label="$t('sitesAndDevices.kioskActions.rebootTime')"
          id="robot"
          label-for="time_reboot"
        >
          <i
            v-if="form.kiosk_setting.schedule_reboot_time"
            :class="{
              'bg-blue': form.kiosk_setting.schedule_reboot_time != '00:00:00',
              'vp-ml-60': form.kiosk_setting.schedule_reboot_time == '00:00:00',
            }"
            class="mdi mdi-clock mdi-24px clock-icon"
          ></i>

          <i
            @click="clearRebootTime()"
            v-if="form.kiosk_setting.schedule_reboot_time != '00:00:00'"
            class="mdi mdi-close-circle mdi-24px close-icon"
          ></i>
          <date-picker
            class="float-right"
            :class="{
              'no-time-width':
                form.kiosk_setting.schedule_reboot_time == '00:00:00',
              'with-time-width':
                form.kiosk_setting.schedule_reboot_time != '00:00:00',
            }"
            v-model="form.kiosk_setting.schedule_reboot_time"
            type="time"
            value-type="format"
            placeholder="Select Time"
          ></date-picker>
        </b-form-group>
      </div>
    </div>

    <div class="actionsline-inside"></div>

    <div v-if="area_mode == 'signIn_signOut'">
      <b-form-group 
        class="temp-type align-items-center"
        label-cols-sm="12"
        label-cols-lg="12"
        id="signInOutMode"
        :label="$t('sitesAndDevices.kioskActions.signInOutMode')"
        label-for="signInOutMode"
      >
        <div>
          <v-radio-group v-model="form.kiosk_setting.kiosk_sign_in_out_mode" class="signInOutModeRadioGroup">
            <v-radio
              v-for="option in signInOutModeOptions"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
        </div>
      </b-form-group>
            
      <div class="actionsline-inside"></div>
    </div>

    <div class="form-groups mb-3">
      <div class="switch-gray-container mt-16">
        <p class="label">{{ $t('sitesAndDevices.kioskActions.showPreRegistrationQr') }}</p>
        <b-form-checkbox class="switch-gray switch-gray2 toggle-switch" switch size="lg" v-model="form.kiosk_setting.show_pre_registration_qr" />
      </div>

      <p class="show-pre-registration-url-qr-note">
        <b>{{ $t('common.notes.note') }}</b> : {{ $t('sitesAndDevices.kioskActions.showPreRegistrationQrNote') }}
      </p>
    </div>

    <div class="actionsline-inside"></div>
    <!-- Temperature Unit  -->
    <div class="vp-mb-16">
      <b-form-group
        class="temp-type align-items-center"
        :label="$t('sitesAndDevices.kioskActions.temperatureUnit')"
      />
      <v-radio-group v-model="form.kiosk_setting.temperature_display_unit">
        <v-radio :label="'°'+$t('common.temperatureUnits.f')" value="f" />
        <v-radio :label="'°'+$t('common.temperatureUnits.c')" value="c" />
      </v-radio-group>
    </div>

    <!-- weigand output type  -->
    <div>
      <b-form-group
        class="tweigand-output align-items-center"
        :label="$t('sitesAndDevices.kioskActions.weigandOutputType')"
      />
      <v-radio-group v-model="form.kiosk_setting.weigand_output_type">
        <v-radio label="26" value="26" />
        <v-radio label="34" value="34" />
      </v-radio-group>
    </div>

    <div class="actionsline-inside"></div>

    <!-- temperature offset  -->
    <div class="all-con">
      <div
        class="d-flex justify-content-between"
        v-if="getPackageType == 'Cloud'"
        style="width: 415px; align-items: center"
      >
        <h5 class="slider-header">{{ $t("sitesAndDevices.kioskActions.temperatureOffset") }}</h5>
        <div class="average-con">
          <span>
            {{ form.kiosk_setting.temperature_offset }} °{{
              form.kiosk_setting.temperature_display_unit ? $t("common.temperatureUnits." + form.kiosk_setting.temperature_display_unit) : ""
            }}
          </span>
        </div>
      </div>
      <div
        class="d-flex align-items-center"
        style="width: 415px !important; margin-top: 30px; margin-bottom: 38px"
      >
        <b-slider
          v-model="form.kiosk_setting.temperature_offset"
          :min="form.kiosk_setting.temperature_display_unit == 'c' ? -10 : -20"
          :max="form.kiosk_setting.temperature_display_unit == 'c' ? 10 : 20"
          :tooltip-always="false"
          :indicator="false"
          :step="0.1"
          size="is-medium"
          :rounded="true"
        ></b-slider>
      </div>
      <!-- brightness  -->
      <div v-if="getPackageType == 'Cloud'" style="width: 415px">
        <div
          class="d-flex justify-content-between align-items-center"
          style="width: 415px; align-items: center"
        >
          <h5 class="slider-header">{{ $t("sitesAndDevices.kioskActions.brightness") }}</h5>
          <div class="average-con">
            <span> {{ form.kiosk_setting.kiosk_brightness }} % </span>
          </div>
        </div>
        <div
          class="d-flex align-items-center"
          style="width: 415px !important; margin-top: 30px; margin-bottom: 38px"
        >
          <b-slider
            v-model="form.kiosk_setting.kiosk_brightness"
            :min="0"
            :max="100"
            :tooltip-always="false"
            :indicator="false"
            size="is-medium"
            :rounded="true"
          ></b-slider>
        </div>
      </div>
      <!-- volume  -->

      <div v-if="getPackageType == 'Cloud'" style="width: 415px">
        <div
          class="d-flex justify-content-between align-items-center"
          style="width: 415px; align-items: center"
        >
          <h5 class="slider-header">{{ $t("sitesAndDevices.kioskActions.volume") }}</h5>
          <div class="average-con">
            <span> {{ form.kiosk_setting.kiosk_volume }} % </span>
          </div>
        </div>
        <div
          class="d-flex align-items-center"
          variant="primary"
          style="width: 415px !important; margin-top: 30px; margin-bottom: 38px"
        >
          <b-slider
            v-model="form.kiosk_setting.kiosk_volume"
            :min="0"
            :max="100"
            :tooltip-always="false"
            :indicator="false"
            size="is-medium"
            :rounded="true"
          ></b-slider>
        </div>
      </div>

      <!-- rfid counter  -->

      <div v-if="getPackageType == 'Cloud'" style="width: 415px">
        <div
          class="d-flex justify-content-between align-items-center"
          style="width: 415px; align-items: center"
        >
          <h5 class="slider-header">{{ $t("sitesAndDevices.kioskActions.rfidCounterSeconds") }}</h5>
          <div class="average-con">
            <span> {{ form.kiosk_setting.rfid_counter }} {{ $t("common.sec") }} </span>
          </div>
        </div>
        <div
          class="d-flex align-items-center"
          variant="primary"
          style="width: 415px !important; margin-top: 30px; margin-bottom: 38px"
        >
          <b-slider
            v-model="form.kiosk_setting.rfid_counter"
            :min="0"
            :max="10"
            :tooltip-always="false"
            :indicator="false"
            size="is-medium"
            :rounded="true"
          ></b-slider>
        </div>
      </div>
    </div>
    <!-- custom_smtp_server  -->

    <div class="actionsline-inside" style="margin-inline-start: 36px"></div>
    <div class="smpt-con">
      <b-form-group
        v-if="getPackageType == 'Cloud'"
        label-cols-sm="12"
        label-cols-lg="12"
        id="rfid_counter:"
        :label="$t('sitesAndDevices.kioskActions.customSmtpServer')"
        label-for="custom_smtp_server"
      >
        <b-form-checkbox
          size="md"
          class="switch-gray radio-updateArea"
          id="custom_smtp_server"
          switch
          v-model="form.kiosk_setting.custom_smtp_server"
          style="padding-inline-start: 3rem !important"
        ></b-form-checkbox>
      </b-form-group>
      <!-- <div class="actionsline-inside"></div> -->

      <!-- smtp settings  -->
      <div
        class="smtp_settings vp-mt-30"
        v-if="
          form.kiosk_setting.custom_smtp_server && getPackageType == 'Cloud'
        "
      >
        <!-- server address  -->
        <vpInput
          v-model="form.kiosk_setting.smtp_address"
          type="text"
          :label="$t('sitesAndDevices.kioskActions.serverAddress')"
          :class="{
            'is-invalid':
              submitted && $v.form.kiosk_setting.smtp_address.$error,
          }"
        />

        <vpInput
          v-model="form.kiosk_setting.smtp_port"
          type="text"
          :label="$t('sitesAndDevices.kioskActions.port')"
          :class="{
            'is-invalid': submitted && $v.form.kiosk_setting.smtp_port.$error,
          }"
        />

        <vpInput
          v-model="form.kiosk_setting.smtp_username"
          type="text"
          :label="$t('sitesAndDevices.kioskActions.username')"
          :class="{
            'is-invalid':
              submitted && $v.form.kiosk_setting.smtp_username.$error,
          }"
        />

        <vpInput
          v-model="form.kiosk_setting.smtp_password"
          type="password"
          :label="$t('sitesAndDevices.kioskActions.password')"
          :passwordIcon="false"
          :class="{
            'is-invalid':
              submitted && $v.form.kiosk_setting.smtp_password.$error,
          }"
        />

        <div class="d-flex vp-ml-25">
          <!-- smtp_tls  -->
          <div class="d-flex flex-column" style="margin-inline-end: 30px">
            <!-- smtp_tls  -->
            <b-form-group
              class="pt-4 vp-ml-minus-20"
              id="rfid_counter:"
              :label="$t('sitesAndDevices.kioskActions.enableTls')"
              label-for="smtp_tls"
            />
            <b-form-checkbox
              class="switch-gray radio-updateArea pb-5 "
              size="md"
              id="smtp_tls"
              switch
              v-model="form.kiosk_setting.smtp_tls"
            ></b-form-checkbox>
          </div>
          <div
            class="vertical-line"
            style="
              width: 1px;
              background: #707070;
              height: 34px;
              margin-top: 40px;
              opacity: 0.15;
            "
          ></div>
          <div class="d-flex flex-column" style="margin-inline-start: 45px">
            <!-- smtp_ssl  -->
            <b-form-group
              class="pt-4 vp-ml-minus-20"
              id="rfid_counter:"
              :label="$t('sitesAndDevices.kioskActions.enableSsl')"
              label-for="smtp_ssl"
            />
            <b-form-checkbox
              class="switch-gray radio-updateArea pb-5"
              size="md"
              id="smtp_ssl"
              switch
              v-model="form.kiosk_setting.smtp_ssl"
            ></b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="actionsline-inside"></div>
    </div>
    <!-- password setting  -->
    <b-form-group v-if="getPackageType == 'Cloud'">
      <Collapsible
        class="Collapsible"
        openLabel="Close Builder Settings"
        closedLabel="Open Builder Settings"
        :isOpen="false"
      >
        <div slot="trigger">
          <div class="customTrigger d-flex align-items-center">
            <h4
              @click="isPasswordSettingsOpened = !isPasswordSettingsOpened"
              class="mb-0 d-flex align-items-center"
              :class="{
                openedPassword: isPasswordSettingsOpened,
                closedPassword: !isPasswordSettingsOpened,
              }"
            >
              {{ $t('sitesAndDevices.kioskActions.passwordSettings') }}
            </h4>
            <svg
              style="margin-top: 5px"
              v-if="!isPasswordSettingsOpened"
              width="9"
              height="5"
              viewBox="0 0 9 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.67656 4.64C3.76718 4.74474 3.87934 4.82877 4.00544 4.88637C4.13154 4.94396 4.26863 4.97377 4.40732 4.97377C4.54601 4.97377 4.68306 4.94396 4.80916 4.88637C4.93526 4.82877 5.04746 4.74474 5.13808 4.64L8.59337 0.809998C8.99434 0.362998 8.83696 0 8.23451 0L0.580093 0C-0.0213532 0 -0.179705 0.365998 0.221259 0.809998L3.67656 4.64Z"
                fill="#787878"
              />
            </svg>
            <svg
              style="margin-top: 5px"
              v-else
              width="9"
              height="5"
              viewBox="0 0 9 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.13594 0.336563C5.04532 0.231826 4.93316 0.147792 4.80706 0.0901951C4.68096 0.0325984 4.54387 0.00279273 4.40518 0.00279274C4.26649 0.00279276 4.12944 0.0325984 4.00334 0.0901951C3.87724 0.147792 3.76504 0.231826 3.67442 0.336564L0.219126 4.16657C-0.181838 4.61357 -0.0244579 4.97656 0.57799 4.97656L8.23241 4.97656C8.83385 4.97656 8.99221 4.61056 8.59124 4.16656L5.13594 0.336563Z"
                fill="#103F5E"
              />
            </svg>
          </div>
        </div>

        <div
          v-if="getPackageType == 'Cloud'"
          class="password-settings-container vp-mt-30"
        >
          <!-- current password  -->
          <vpInput
            v-model="current_kiosk_password"
            type="password"
            :label="$t('sitesAndDevices.kioskActions.currentPassword')"
            :passwordIcon="false"
          />

          <!-- new password  -->
          <vpInput
            v-model="form.kiosk_setting.kiosk_password"
            type="password"
            id="new_kiosk_password"
            :label="$t('sitesAndDevices.kioskActions.newPassword')"
            :passwordIcon="false"
          />

          <!-- confirm new password  -->
          <vpInput
            v-model="form.kiosk_setting.confirm_kiosk_password"
            type="password"
            :label="$t('sitesAndDevices.kioskActions.confirmNewPassword')"
            :passwordIcon="false"
          />

          <!-- <div
                v-if="$v.form.kiosk_setting.confirm_kiosk_password.$error"
                class="invalid-feedback"
              >
                <span
                  v-if="
                    !$v.form.kiosk_setting.confirm_kiosk_password.sameAsPassword
                  "
                >
                  Password and confirmation password do not match
                </span>
              </div> -->
        </div>
      </Collapsible>
    </b-form-group>

    <div class="actionsline-inside"></div>

    <div class="door-relay-mode-container">
      <h4 class="subheader">{{ $t('sitesAndDevices.kioskActions.doorRelayMode') }}</h4>
      <v-radio-group v-model="form.kiosk_setting.door_relay_mode">
        <v-radio :label="$t('sitesAndDevices.kioskActions.mode0')" value="mode0_high" />
        <p class="radio-note">{{ $t('sitesAndDevices.kioskActions.noAutomaticClosingModeOnHighVoltage') }}</p>

        <v-radio :label="$t('sitesAndDevices.kioskActions.mode0')" value="mode0_low" />
        <p class="radio-note">{{ $t('sitesAndDevices.kioskActions.noAutomaticClosingModeOnLowVoltage') }}</p>

        <v-radio :label="$t('sitesAndDevices.kioskActions.mode1')" value="mode1_high" />
        <p class="radio-note">
          {{ $t('sitesAndDevices.kioskActions.automaticClosingModeHighEffective') }}
        </p>

        <v-radio :label="$t('sitesAndDevices.kioskActions.mode2')" value="mode2_low" />
        <p class="radio-note">
          {{ $t('sitesAndDevices.kioskActions.automaticClosingModeLowEffective') }}
        </p>
      </v-radio-group>
    </div>

    <div class="actionsline-inside"></div>

    <vpInput
      type="number"
      :label="$t('sitesAndDevices.kioskActions.closingDelaySeconds')"
      v-model="form.kiosk_setting.closing_delay"
      maxlength="5"
      @blur="checkIfValueIsNull"
    />

    <div class="actions-btns">
      <button
        :disabled="getLoading || $v.form.$invalid"
        class="submit-btn btn btn-primary add-submit"
        size="md"
        @click="onSubmit"
      >
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        {{ siteInfoLength > 0 ? $t('common.save') : $t('common.submit') }}
      </button>
      <button
        class="btn btn-outline-danger cancel-reject"
        @click="$bvModal.hide(modal_id)"
      >
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>
<style lang="scss">
div[id*="kioskSetting_"] {
  div[class*="modal-content"] {
    div[class*="modal-body"] {
      padding: 0 !important;
      .d-block {
        font-weight: 700;
        font-size: 16px;
        color: #787878;
        letter-spacing: 0.25px;
        line-height: 17px;
      }
      .subheader {
        color: #787878;
        font-weight: 700;
        margin-bottom: 30px;
        font-size: 16px;
      }
      .password-settings-container > div:not(:last-of-type) {
        margin-bottom: 16px;
      }
      .smtp_settings > div:not(:last-of-type) {
        margin-bottom: 16px;
      }

      .door-relay-mode-container {
        .v-input--radio-group__input {
          flex-direction: column !important;
        }
      }
      .radio-note {
        color: #787878;
        width: 370px;
        font-weight: 400;
        font-size: 14px;
        margin-top: -30px;
        margin-inline-end: 0;
        margin-bottom: 0px;
        margin-inline-start: 35px;
      }
      .kiosk-switch-settings {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap-reverse;
      }
      .kiosk-switch-settings > div {
        font-weight: 700 !important;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .login-mode2 {
        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: rgba(96, 96, 96, 0.87);

        .custom-control-input:checked ~ label.custom-control-label {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #103f5e;
        }
      }
      .kiosk-form-wrapper {
        overflow: hidden;
        width: 415px;
        margin: auto;
        .b-slider-track,
        .b-slider-fill {
          width: 390px;
          margin: auto;
          background-color: #0a293d !important;
        }
        .b-slider.is-medium .b-slider-thumb::after {
          content: "||";
          opacity: 0.2;
          color: #000000;
          position: absolute;
          top: 10%;
          inset-inline-start: 33%;
          font-size: 10px;
        }

        .login-mode {
          font-weight: 400;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: rgba(96, 96, 96, 0.87);
          // label.custom-control-label {
            // padding-inline-start: 20px;
          // }
          // .custom-control-input:checked ~ label.custom-control-label {
          //   font-weight: 700;
          //   font-size: 16px;
          //   line-height: 17px;
          //   letter-spacing: 0.25px;
          //   color: #103f5e;
          // }
        }
        .allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin: 30px 0;
        }
        .switchs-wrapper {
          .line-betwen {
            height: 40px;
            width: 1px;
            opacity: 0.15;
            background: #707070;
          }
        }

        .multi-inputs {
          .actionsline-inside {
            background: #707070;
            height: 1px;
            opacity: 0.15;
            margin: 30px auto !important;
            width: 415px;
          }
        }
        h5.slider-header {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
        }
        .average-con {
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f2f2f2;
          border-radius: 7px;
          width: 89px;
          span {
            font-weight: 700;
            font-size: 20px;
            line-height: 46px;
            display: flex;
            align-items: center;
            letter-spacing: 0.25px;
            color: rgba(96, 96, 96, 0.87);
            opacity: 0.8;
          }
        }

        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          margin: 30px auto !important;
        }

        label#rfid_counter\:__BV_label_ {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
        }
        .openedPassword {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #103f5e;
        }
        .closedPassword {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          margin-bottom: 60px;
          letter-spacing: 0.25px;
          color: #787878;
        }
        .actions-btns {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          margin: 40px 0;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
        .temp-type,
        .tweigand-output {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
          & label {
            font-weight: 700;
          }
        }
        label#robot__BV_label_ {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
          margin-top: 10px;
        }
        input.mx-input {
          height: 55px !important;
          background: #f2f2f2 !important;
          border-radius: 4px;
          border: none !important;
        }
        div#robot-time {
          width: 183px !important;
          font-weight: 700 !important;
          font-size: 16px !important;
          line-height: 17px !important;
          letter-spacing: 0.25px;
          color: rgba(0, 0, 0, 0.87);
          opacity: 0.8;
          ::placeholder {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            color: #787878;
          }
        }
      }

      .show-pre-registration-url-qr-note{
        width: 416px !important;
        margin-top: 8px;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.25px;
        color: #787878;
      }
    }
  }
  .mx-input-wrapper input[type="text"] {
    padding-inline-start: 45px !important;
    font-size: 20px !important;
  }

  .clock-icon {
    position: absolute;
    z-index: 1;
    inset-inline-start: 15px;
    bottom: 25px;
  }
  .close-icon {
    position: absolute;
    z-index: 1;
    inset-inline-end: 4px;
    top: 10px;
    color: #f46a6a;
    cursor: pointer;
  }
  .no-time-width {
    width: 140px !important;
  }
  .with-time-width {
    width: 202px !important;
  }
  .bg-blue {
    color: #103f5e;
    inset-inline-start: 10px;
  }

  .mx-icon-clear,
  .mx-icon-calendar {
    display: none !important;
  }
}
</style>
